module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-2-nad_600px_width-0_1.7c74c4be.png";